import { Badge } from "@marekl/adminer/components";
import { ageSlotClass, ageSwatchClass, type AgeColorSlot } from "./ageColors";

/** A colour swatch for the rule-set picker. */
export function AgeSwatch({ color }: { color: AgeColorSlot }) {
  return <span className={ageSwatchClass(color)} />;
}

/**
 * An age category, rendered the same way everywhere it is named.
 *
 * The colour is rule-set data, so this component is the only thing that
 * turns a slot into pixels. Anything that reaches for the palette itself
 * is how „SENIOR" ends up plum on one screen and untinted on the next.
 *
 * No colour is a legitimate state, not a gap: a rule set that has never
 * assigned one gets a plain muted badge, which is what every age category
 * looked like before the palette existed.
 */
export function AgeBadge({ name, color }: { name: string; color?: string }) {
  return (
    <Badge variant="muted" className={ageSlotClass(color)}>
      {name}
    </Badge>
  );
}
